import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';

import { TabComponent } from '@Common/Layout/components/Tab/tab.component';
import { BriefingModel } from '@Monitor/Briefings/models/briefing.model';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { ScrollPanelComponent } from '@Common/Basic/components/ScrollPanel/scroll-panel.component';
import { SortToolComponent } from '../SortTool/sort-tool.component';
import { BriefingDeliveryMethodEnum } from '../../enums/briefing-delivery-method.enum';
import { BriefingStatusEnum } from '../../../../Common/MonitorShared/enum/briefing-status.enum';

@Component({
    selector: 'agpr-briefing-compose-tab',
    templateUrl: './briefing-compose-tab.component.html',
    styleUrls: ['./briefing-compose-tab.component.scss'],
    providers: [
        {
            provide: TabComponent,
            useExisting: BriefingComposeTabComponent
        }
    ],
    standalone: false
})
export class BriefingComposeTabComponent extends TabComponent {

    public readonly messageSeverityEnum = messageSeverityEnum;
    public readonly briefingDeliveryMethods = BriefingDeliveryMethodEnum;
    public readonly briefingStatusEnum = BriefingStatusEnum;

    @Input() selectedTabIndex: number;
    @Input() sortToolTabIndex: number;
    @Input() showNoBlocksSelectedErrorMsg: boolean;
    @Input() loadingBriefing: boolean;
    @Input() briefing: BriefingModel;
    @Input() inlineAdderAdjustment: boolean;
    @Input() actionMenuTextAlignment: string;

    @Output() scrollToAddedBlock: EventEmitter<ElementRef> = new EventEmitter();
    @Output() selectedMentionChange: EventEmitter<any> = new EventEmitter();
    @Output() selectBlockEditTab: EventEmitter<void> = new EventEmitter();
    @Output() doDraggingMentions: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('sortTool') sortTool: SortToolComponent;
    @ViewChild('scrollPanel') scrollPanel: ScrollPanelComponent;

    constructor() {
        super();
    }
}
